import React from 'react';
import PropTypes from 'prop-types';
import Link from 'zignal-landscape/lib/Link';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isBoolean from 'lodash/isBoolean';
import isEmpty from 'lodash/isEmpty';
import flattenDeep from 'lodash/flattenDeep';
import get from 'lodash/get';
import papaparse from 'papaparse';
import ExportIcon from 'zignal-landscape/lib/Icon/ExportIcon';

class Exporter extends React.Component {
  constructor(props) {
    super(props);

    this.doExport = this.doExport.bind(this);
    this.MIME_TYPE_CSV = 'text/csv; charset=UTF-8';
    this.MIME_TYPE_TSV = 'text/tab-separated-values; charset=UTF-16LE';
    this.QUOTE = '"';
  }

  getPaths(object, path = []) {
    return flattenDeep(Object.keys(object).map((key) => {
      if (isObject(object[key])) {
        return this.getPaths(object[key], path.concat([key]));
      }
      if (path) {
        return path.concat([key]).join('.');
      }
      return key;
    }));
  }

  getXSVData() {
    const data = this.prepareData();
    const { format } = this.props;

    let delimiter;
    let mimeType;

    switch(format) {
      case 'TSV':
        delimiter = '\t';
        mimeType = this.MIME_TYPE_TSV;
        break;
      case 'CSV':
      default:
        delimiter = ',';
        mimeType = this.MIME_TYPE_CSV;
        break;
    }

    const csv = papaparse.unparse(data, {
      delimiter,
    });

    return `data:${mimeType},${encodeURIComponent(csv)}`;
  }

  prepareData() {
    const { mapping, data } = this.props;
    let headers = null;
    let paths = null;
    if (isObject(mapping) && !isEmpty(mapping)) {
      paths = this.getPaths(mapping);

      headers = paths.map((path) => {
        return get(mapping, path);
      });
    } else {
      // if no mappings are defined then use the keys of the first object
      // eslint-disable-next-line
      if (data[0]) {
        headers = Object.keys(data[0]);
        paths = headers;
      }
    }
    if (headers && paths) {
      const body = data.map((row) => {
        return paths.map((path) => {
          const value = get(row, path, null);
          switch (true) {
            case isBoolean(value):
              return value ? 'Yes' : 'No';
            case isArray(value):
              return value.length > 0 ? value.join(',') : 'None';
            default:
              return value;
          }
        });
      });
      return [headers, ...body];
    }
    return [];
  }

  doExport() {
    return window.open(this.getXSVData(), '_blank');
  }

  render() {
    const { text } = this.props;
    return (
      <Link onClick={this.doExport} icon={<ExportIcon />}>{text}</Link>
    );
  }
}

Exporter.propTypes = {
  mapping: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  format: PropTypes.oneOf(['CSV', 'TSV']),
  text: PropTypes.string,
};

Exporter.defaultProps = {
  format: 'CSV',
  text: 'Export results',
};

export default Exporter;
